import MaskDesignerOverlay from './MaskDesignerOverlay.vue';

type DesignerOverlayContext = {
  viewName: string;
  config: Record<string, unknown>;
};

type DesignerFacade = {
  designer?: {
    registerOverlay?: (overlay: {
      id: string;
      priority?: number;
      render: (ctx: DesignerOverlayContext) => { component: unknown; props?: Record<string, unknown> };
    }) => void;
  };
};

let registered = false;

function register(): void {
  const Veyop = (window as unknown as { Veyop?: DesignerFacade }).Veyop;
  if (registered || !Veyop?.designer?.registerOverlay) return;
  registered = true;

  Veyop.designer.registerOverlay({
    id: 'mask-images',
    priority: 10,
    render: (ctx) => ({ component: MaskDesignerOverlay, props: { context: ctx } }),
  });
}

function boot(): void {
  register();
  const start = Date.now();
  const tick = () => {
    register();
    if (registered || Date.now() - start > 5000) return;
    setTimeout(tick, 50);
  };
  tick();
}

boot();
